import { useTranslation } from "react-i18next";
import cn from "classnames";

import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { PanelContainer, StepsContainer, Heading } from "@/basic/components";

import { useCheckCurrentScreen } from "@/basic/hooks";

import styles from "./styles.module.scss";

export const JourneySteps = () => {
  const { t: translate } = useTranslation();
  const screen = useCheckCurrentScreen();
  const wideScreen = screen === "desktop" || screen === "tablet";

  const divingLineClass = cn(styles["DivingLine"], { [styles["hide"]]: !wideScreen });

  const stepsClass = cn({ [styles["StepsContainerMobile"]]: !wideScreen });

  const steps = (
    <>
      <StepsContainer
        active
        name="placeholder"
        title={`${translate("JOURNEY_STEPS.stepOne")}:`}
        description={translate("JOURNEY_STEPS.discoverPharmacies")}
        className={stepsClass}
      />

      <hr className={divingLineClass} />

      <StepsContainer
        name="placeholder"
        title={`${translate("JOURNEY_STEPS.stepTwo")}:`}
        description={translate("JOURNEY_STEPS.signUpForYourPlan")}
        color="lightgrey"
        className={stepsClass}
      />

      <hr className={divingLineClass} />

      <StepsContainer
        name="placeholder"
        title={`${translate("JOURNEY_STEPS.stepThree")}:`}
        description={translate("JOURNEY_STEPS.monitorYourPlan")}
        color="lightgrey"
        className={stepsClass}
      />
    </>
  );

  const stepsContent = wideScreen ? <Shelf>{steps}</Shelf> : <Stack>{steps}</Stack>;

  return (
    <PanelContainer>
      <Stack spacing="large">
        <Heading>{translate("JOURNEY_STEPS.welcomeToYourPharmacy")}</Heading>
        {stepsContent}
      </Stack>
    </PanelContainer>
  );
};
